import { axiosInstance } from '~/services/fetchServiceV2';

import { useDedupeMutation } from '../common';

type TypeChangePhoneNumberRequestSmsParams = {
  phoneNumber: string;
};

type TypeChangePhoneNumberRequestSmsResponse = {
  code: string;
  message: string;
};

/** @description비밀번호 변경을 위한 인증번호 요청 api에 사용되는 커스텀 훅 */
export const useChangePhoneNumberRequestSms = () => {
  return useDedupeMutation<TypeChangePhoneNumberRequestSmsParams, TypeChangePhoneNumberRequestSmsResponse>({
    mutationFn: (params: TypeChangePhoneNumberRequestSmsParams) => {
      const endpoint = '/labor-accounts/phone-verification/for-modify-phone-number';
      return axiosInstance.post(endpoint, params);
    },
  });
};
